<template>
    <div id="app">
        <loading ref="loading" />

        <transition name="page" mode="out-in">
            <div v-if="layout" :id="'layout-' + layout.name">
                <component :is="layout" />
            </div>
        </transition>
    </div>
</template>

<script>
    window.quasarConfig = {
        brand: { // this will NOT work on IE 11
            primary: '#3a7cb5',
            // ... or all other brand colors
        }
    }
    import Loading from './Loading'

    // Load layout components dynamically.
    const requireContext = require.context('~/layouts', false, /.*\.vue$/)

    const layouts = requireContext.keys()
        .map(file =>
            [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
        )
        .reduce((components, [name, component]) => {
            components[name] = component.default || component
            return components
        }, {})

    export default {
        el: '#app',

        components: {
            Loading
        },

        data: () => ({
            layout: null,
            defaultLayout: 'admin'
        }),

        metaInfo() {
            const { appName } = window.config

            return {
                title: appName,
                titleTemplate: `%s · ${appName}`
            }
        },

        mounted() {
            this.$loading = this.$refs.loading
        },

        methods: {
            /**
             * Set the application layout.
             *
             * @param {String} layout
             */
            setLayout(layout) {
                if (!layout || !layouts[layout]) {
                    layout = this.defaultLayout
                }

                this.layout = layouts[layout]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/App.vue